import { TradeTapeItem } from '@paradigm/features/src/unified-rfqs/entities/shared';

/**
 * The VISIBLE `/analyze` prompt — what shows in the chat bubble. Just the rfq
 * id + human-readable summary; the full data rides separately as hidden
 * context (see `buildTradeAnalysisContext`) so the bubble stays clean.
 */
export function buildTradeAnalysisPrompt(trade: TradeTapeItem): string {
  return `/analyze ${trade.rfq_id} ${trade.description}`;
}

/**
 * HIDDEN context for the `/analyze`d trade — the full structured row, sent to
 * the gateway via `sendMessage(text, { context })` but never shown in the
 * bubble. This is what actually gives the agent size/legs/premium/IV/side/mark
 * to analyze, since the gateway doesn't implement `set_block_trade_context`.
 * Serialization failures fall back to no context (the prompt still sends).
 */
export function buildTradeAnalysisContext(trade: TradeTapeItem): string {
  try {
    return `Trade data for ${trade.rfq_id} (JSON):\n${JSON.stringify(trade)}`;
  } catch {
    return '';
  }
}
